module.exports = __webpack_public_path__ + "img/卧室_image.98acbbeb.png";